import { createFileRoute } from '@tanstack/react-router'
import { publicReportFormSchema } from 'shared'
import { useAppForm } from '@/lib/use-app-form'
import { AuthPending } from './-components/app-layout-skeleton'

export const Route = createFileRoute('/_app/beta/generate')({
  component: RouteComponent,
  pendingComponent: AuthPending,
})

function RouteComponent() {
  const form = useAppForm({
    validators: { onChange: publicReportFormSchema },
    defaultValues: {
      // Widen to match the optional schema field so form defaultValues typecheck.
      // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
      name: '' as string | undefined,
      answers: '',
    },
    onSubmit: ({ value }) => {
      window
        .open(
          `/beta/report?${new URLSearchParams({
            profiles: JSON.stringify({
              first: {
                type: 'public',
                name: value.name,
                ...JSON.parse(value.answers),
              },
              selected: 'first',
              type: 'competences',
            }),
          })}`,
          '_blank',
        )
        ?.focus()
    },
  })
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        form.handleSubmit()
      }}
      className="mx-auto flex max-w-96 flex-col gap-4 p-6"
    >
      <form.AppField name="name" children={(field) => <field.TextField label="name" />} />
      <form.AppField name="answers" children={(field) => <field.TextField label="answers" />} />
      <button type="submit">generate</button>
    </form>
  )
}
